import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { baseQueryWithReauth } from "./base-query";

export const api = createApi({
  reducerPath: "api",
  tagTypes: [
    "user",
    "requests",
    "language",
    "Conversations",
    "ConversationHistory",
    "Goals",
    "UserExercises",
    "Therapist",
    "Consent",
    "UserAppointments",
  ],
  baseQuery: baseQueryWithReauth,
  endpoints: () => ({}),
});
